import OBase from './OBase';

import * as Geometry from '../geometry';

export default class EPaintList extends OBase {
  update () {
    const output = this.outputs['paintId'].paramObject;
    const selected = Number(this.ghGeometryObject.selected);
    const oTree = new Geometry.DataTree();
    if (selected >= 0 && selected < this.ghGeometryObject.values.length) {
      const value = this.ghGeometryObject.values[selected];
      oTree.add(value, new Geometry.GHPath(0));
    } else {
      oTree.add(null, new Geometry.GHPath(0));
    }
    output.value = oTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EPaintList.js